import React from "react";

const steps = [
  {
    title: "Set Pickup & Drop Location",
    description: "Enter where you want to start and end your trip.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17.657 16.657L13.414 12.414a2 2 0 00-2.828 0L6.343 16.657m11.314 0a9 9 0 11-12.728 0 9 9 0 0112.728 0z"
        />
      </svg>
    ),
  },
  {
    title: "Choose Preferred Vehicle Type",
    description: "Pick Economy, Standard, Luxury, or other options.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 10h1l1 5h12l1-5h1m-1-6h-3a2 2 0 00-2 2v1H9V6a2 2 0 00-2-2H4a1 1 0 00-1 1v3h1m6 11v1a2 2 0 11-4 0v-1h4z"
        />
      </svg>
    ),
  },
  {
    title: "Select from Filtered Cars",
    description: "See available cars filtered by your selected vehicle type.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 10h1l1 5h12l1-5h1m-7-6v6m0 0L8 8m4 2l4-4"
        />
      </svg>
    ),
  },
  {
    title: "Select Seats & Confirm Booking",
    description: "Choose your seats, review booking details, and make payment.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    ),
  },
];

const HowItWorks = () => {
  return (
    <section className="py-16 px-6 md:px-16 bg-gray-100 font-lato">
      <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
        How It Works
      </h2>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {steps.map(({ title, description, icon }, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center space-y-4 p-6 border rounded-lg shadow-sm hover:shadow-md transition"
          >
            <div className="bg-blue-100 rounded-full p-4">{icon}</div>
            <h3 className="text-xl font-semibold text-blue-700">{title}</h3>
            <p className="text-gray-600 text-sm">{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
